export default __webpack_public_path__ + "static/media/ic_error_outline_48px.53dcaa95.svg";